import { denormalize } from 'normalizr';
import isString from 'lodash/isString';

export default (EntitySchema, ListSchema) => (ids, entities) => {
  const schema = isString(ids) ? EntitySchema : ListSchema;

  return denormalize(ids, schema, entities);
};
